import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {_formatNameTemplatePart} from 'name-templates/FormatNameTemplatePart';
import {
  NameTemplatePart,
  NameTemplatePartType,
  nameTemplatePartChipStyles,
} from 'name-templates/NameTemplateConstants';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {ElementDragEvent, Optional} from 'util/Types';

import NameTemplatePartConfiguration from './NameTemplatePartConfiguration';

export interface NameTemplatePartChipProps {
  draggable?: boolean;
  onDragStart?: (e: ElementDragEvent) => void;
  onDragOver?: (e: ElementDragEvent) => void;
  onDrop?: (e: ElementDragEvent) => void;
  nameTemplatePart: NameTemplatePart;
  schemaFields: Array<SchemaField | ClientSchemaField>;
  nameTemplatePartConfiguration?: NameTemplatePartConfiguration;
  // If specified, the chip is rendered with an x which calls this callback.
  onRemove?: () => void;
}

function formatNameTemplatePartTooltip(nameTemplatePart: NameTemplatePart): Optional<string> {
  switch (nameTemplatePart.type) {
    case NameTemplatePartType.TEXT:
      return 'Text';
    case NameTemplatePartType.SEPARATOR:
      return 'Separator';
    default:
      return null;
  }
}

export default function NameTemplatePartChip({
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  nameTemplatePart,
  schemaFields,
  onRemove,
  nameTemplatePartConfiguration,
}: NameTemplatePartChipProps): JSX.Element {
  return (
    <Chip
      className={classNames({[css(nameTemplatePartChipStyles.dragCursor)]: draggable})}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onRemove={onRemove}
      size={ChipSize.MINI}
      text={_formatNameTemplatePart(nameTemplatePart, schemaFields, nameTemplatePartConfiguration)}
      tooltipTitle={formatNameTemplatePartTooltip(nameTemplatePart)}
    />
  );
}
